import { useEffect } from "react";
import { Button, ButtonGroup } from "react-bootstrap";

import { faCheck, faMultiply } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const BoolColumnFilter = ({
	column: { filterValue, setFilter, defaultFilterValue },
}) => {
	useEffect(() => {
		if (defaultFilterValue !== undefined && filterValue === undefined) {
			setFilter(defaultFilterValue);
		}
	}, []);

	const currentState =
		filterValue === undefined
			? "all"
			: filterValue === true
			? "true"
			: "false";

	const handleClick = (value) => {
		if (value === "all") {
			setFilter(undefined);
		} else {
			setFilter(value === "true");
		}
	};

	return (
		<ButtonGroup size="sm" style={{ width: "75px" }}>
			<Button
				variant={
					currentState === "all" ? "primary" : "outline-secondary"
				}
				onClick={() => handleClick("all")}
				style={{
					fontSize: "11px",
					padding: "2px 4px",
				}}
			>
				All
			</Button>
			<Button
				variant={
					currentState === "true" ? "success" : "outline-secondary"
				}
				onClick={() => handleClick("true")}
				style={{
					fontSize: "11px",
					padding: "2px 4px",
				}}
				aria-label="True"
			>
				<FontAwesomeIcon icon={faCheck} />
			</Button>
			<Button
				variant={
					currentState === "false" ? "danger" : "outline-secondary"
				}
				onClick={() => handleClick("false")}
				style={{
					fontSize: "11px",
					padding: "2px 4px",
				}}
				aria-label="False"
			>
				<FontAwesomeIcon icon={faMultiply} />
			</Button>
		</ButtonGroup>
	);
};
